import './Contact.scss';
import Footer from '../Fix/Footer/Footer';
import { useContext } from 'react';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';
import { useForm } from 'react-hook-form';

function Contact() {
  const langs = useContext(LangContext);
  const contactLangs = langs.contact;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];

  // React hook form
    const {
      register,
      handleSubmit,
      reset,
      watch,
      formState: { errors },
    } = useForm();
  
    const onSubmit = (data) => {
      console.log(data, errors);
      reset();
    };
  
    // console.log(watch("nom"), watch("prenom"), watch("email"), watch("message"), errors);

  return (
    <section id="contact" className="Contact">
      <div className="Contact_container">
        <div className="contact_text">
          <div className="contact_text_content">
            <h1>{contactLangs.title[currentLang][0]}</h1>
            <p>{contactLangs.title[currentLang][1]}</p>
            <p>{contactLangs.title[currentLang][2]}</p>
            <p>{contactLangs.title[currentLang][3]}</p>
          </div>
        </div>
        <div className="contact_form">
          <form  onSubmit={handleSubmit(onSubmit)}>
            <div className="contact_name">
              <input type="text" id="nom" name="nom" {...register("nom", { required: true })} placeholder={contactLangs.form[currentLang][0]} />
              <input type="text" id="prenom" name="prenom" {...register("prenom", { required: true })} placeholder={contactLangs.form[currentLang][1]} />
            </div>
            <input type="email" id="email" name="email" {...register("email", { required: true })} placeholder={contactLangs.form[currentLang][2]} />
            <textarea id="message" name="message" {...register("message", { required: true })} placeholder={contactLangs.form[currentLang][3]} />
            {(errors.nom || errors.prenom || errors.email || errors.message) && <span className="errors">* {contactLangs.form[currentLang][5]}</span>}
            <button>{contactLangs.form[currentLang][4]}</button>
          </form>
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default Contact;